import React from 'react';

const VaanOurProjectsHeader = () => {
  return (
    <div className="vaanourproject-header">
      <h1 className="vaanourproject-title">Our Projects</h1>
      <p className="vaanourproject-subtitle">
        Explore our portfolio of successful projects delivered across various industries
      </p>
    </div>
  );
};

export default VaanOurProjectsHeader;